<template>
  <div class="marketing-info">
  <v-card>
        <v-app-bar flat >
          <v-icon>mdi-newspaper</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('global.news')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
          <v-carousel
           cycle
           height="300"
           v-if="items"
           hide-delimiters
           show-arrows-on-hover
         >
           <v-carousel-item
             v-for="(item, i) in items"
             :key="i"
           >
           <v-img
             height="300"
             class="white--text align-end "
             :key="getItemImageKey(item)"
             :src="getImageUrlByObject(item)"
             @click="showHandler(item)"
           >
           <v-card-title class="primary--text black " >
             <span v-if="language == 'fr'">{{ item.namefr }}</span>
             <span v-else>{{ item.name }}</span>
             <v-spacer></v-spacer>
             <v-btn  class="" icon >
               <v-icon>mdi-launch</v-icon>
             </v-btn>
           </v-card-title>

            </v-img>
           </v-carousel-item>
         </v-carousel>


      </v-card>
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from '../../mixins/FileMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'marketingInfo',
  servicePrefix: 'Article',
  mixins: [ListMixin,AccessMixin,FileMixin],

  data() {
    return {
      selected: [],
      filters: {
        'enabled' : true,
      },
      options: {sortBy : ['date'], sortDesc : [true]},
      filter: '1280x700',
      downloadblobwait: false
    };
  },
  components: {


  },
  mounted() {
    this.onUpdateOptions(this.options);
  },
  computed: {
    ...mapGetters('article', {
      items: 'list'
    }),
    ...mapFields('article', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('article', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    showHandler(item) {

      if (item.file) {
        this.$router.push({ name: `ArticleShowLink` , params: { id: item['@id'] }});
      }
      else if (this.language == 'fr') {
        window.open(item.linkfr, "_blank");
      } else {
        window.open(item.link, "_blank");
      }

    },
  },
  watch: {


  }
  
};
</script>
